"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadParticlesAttractInteraction = void 0;

var Attractor_1 = require("./Attractor");

function loadParticlesAttractInteraction(tsParticles) {
  tsParticles.addInteractor("particlesAttract", function (container) {
    return new Attractor_1.Attractor(container);
  });
}

exports.loadParticlesAttractInteraction = loadParticlesAttractInteraction;